import { normalize } from './helper';
import { Dimensions } from 'react-native';

export const SIDE_PADDING = 20;
export const TOP_PADDING = 20;
export const MAX_WIDTH = 700;
export const MAX_WIDTH_MODAL = 500;
export const HEADER_HEIGHT = 50;
export const DEVICE_HEIGHT = Dimensions.get('window').height;
export const DEVICE_WIDTH = Dimensions.get('window').width;

export const TXT_PP = normalize(12);
export const TXT_P = normalize(14);
export const TXT_M = normalize(16);
export const TXT_G = normalize(18);
export const TXT_GG = normalize(20);
